import React, { useState, useEffect } from 'react';
import API from '../api';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer'; 
import * as XLSX from 'xlsx'; 
import '../App.css';

const AdminDashboard = () => {
  const [mechanics, setMechanics] = useState([]);
  const [users, setUsers] = useState([]); 
  const [allRequests, setAllRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);

  const [currentView, setCurrentView] = useState('dashboard');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');

  const loadData = async () => {
    try {
      const mechRes = await API.get('/admin/mechanics');
      const reqRes = await API.get('/admin/requests');
      const userRes = await API.get('/admin/users'); 
      
      setMechanics(mechRes.data);
      setAllRequests(reqRes.data);
      setUsers(userRes.data);
    } catch (err) {
      console.error("Error loading admin data", err);
    }
  };

  useEffect(() => { loadData(); }, []);

  const deleteAccount = async (id, type) => {
    if (window.confirm(`Are you sure you want to delete this ${type}? This action cannot be undone.`)) {
      try {
        await API.delete(`/admin/user/${id}`);
        alert("Account removed successfully.");
        loadData();
      } catch (err) {
        alert("Error deleting account.");
      }
    }
  };

  const approveMechanic = async (id) => {
    if (window.confirm("Approve this mechanic for login?")) {
      await API.put(`/admin/approve/${id}`);
      alert("Mechanic Approved!");
      loadData();
    }
  };

  const downloadReport = () => {
    const reportData = filteredRequests.map(req => ({
      Customer: req.userId?.name || 'N/A',
      Email: req.userId?.email || 'N/A',
      Problem: req.problemType,
      Vehicle: req.vehicleType,
      Location: req.location,
      Phone: req.phone,
      Status: req.status,
      Mechanic: req.mechanicId?.name || 'Unassigned',
      Date: new Date(req.createdAt).toLocaleString('en-IN')
    }));
    const worksheet = XLSX.utils.json_to_sheet(reportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Service Requests");
    XLSX.writeFile(workbook, `OnRoad_Assist_Report_${statusFilter}.xlsx`);
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Completed': return { color: '#28a745', fontWeight: 'bold' }; 
      case 'Accepted': return { color: '#007bff', fontWeight: 'bold' };  
      case 'Declined': return { color: '#dc3545', fontWeight: 'bold' };  
      case 'Pending': return { color: '#ffc107', fontWeight: 'bold' };   
      default: return { fontWeight: 'bold' };
    }
  };

  const filteredRequests = allRequests
    .filter(req => {
      const matchesSearch = req.userId?.name?.toLowerCase().includes(searchTerm.toLowerCase()) || 
                            req.problemType?.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesStatus = statusFilter === 'All' || req.status === statusFilter;
      return matchesSearch && matchesStatus;
    })
    .reverse(); 

  return (
    <>
      <Navbar />
      <div className="container" style={{ minHeight: '80vh' }}>
        
        <div style={{ display: 'flex', gap: '15px', marginBottom: '25px' }}>
          <button 
            className={currentView === 'dashboard' ? "btn-primary" : "btn-outline-gray"} 
            style={{ flex: 1, padding: '15px' }}
            onClick={() => setCurrentView('dashboard')}
          >
            📋 Service Requests
          </button>
          <button 
            className={currentView === 'mechanics' ? "btn-primary" : "btn-outline-gray"} 
            style={{ flex: 1, padding: '15px' }}
            onClick={() => setCurrentView('mechanics')}
          >
            🔧 Mechanics List
          </button>
          <button 
            className={currentView === 'users' ? "btn-primary" : "btn-outline-gray"} 
            style={{ flex: 1, padding: '15px' }}
            onClick={() => setCurrentView('users')}
          >
            👥 Customers List
          </button>
        </div>

        {currentView === 'dashboard' && (
          <>
            <div className="card">
              <h3>Pending Mechanic Approvals</h3>
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th><th>Email</th><th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {mechanics.filter(m => !m.isApproved).length === 0 ? (
                    <tr><td colSpan="3">No pending approvals</td></tr>
                  ) : (
                    mechanics.filter(m => !m.isApproved).map(m => (
                      <tr key={m._id}>
                        <td>{m.name}</td>
                        <td>{m.email}</td>
                        <td>
                          <button className="btn-success" style={{ marginRight: '10px' }} onClick={() => approveMechanic(m._id)}>Approve</button>
                          <button className="btn-danger" onClick={() => deleteAccount(m._id, 'mechanic request')}>Reject</button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div className="card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3 style={{ margin: 0 }}>All Service Requests</h3>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button onClick={downloadReport} className="btn-success" style={{ padding: '8px 15px', fontSize: '13px' }}>📊 Excel</button>
                  <input type="text" placeholder="Search..." onChange={(e) => setSearchTerm(e.target.value)} />
                  <select onChange={(e) => setStatusFilter(e.target.value)}>
                    <option value="All">All Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Accepted">Accepted</option>
                    <option value="Completed">Completed</option>
                    <option value="Declined">Declined</option>
                  </select>
                </div>
              </div>
              <table className="table">
                <thead>
                  <tr>
                    <th>Customer</th><th>Issue (Vehicle)</th><th>Status</th><th>Date</th><th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRequests.map(r => (
                    <tr key={r._id}>
                      <td>{r.userId?.name || 'Unknown'}</td>
                      <td>{r.problemType} ({r.vehicleType || 'N/A'})</td>
                      <td><span style={getStatusStyle(r.status)}>{r.status}</span></td>
                      <td>{new Date(r.createdAt).toLocaleDateString('en-IN')}</td>
                      <td><button className="btn-outline-gray" onClick={() => setSelectedRequest(r)}>Details</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {currentView === 'mechanics' && (
          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3>Registered Mechanics ({mechanics.length})</h3>
              <button className="btn-danger" onClick={() => setCurrentView('dashboard')}>Close</button>
            </div>
            <table className="table">
              <thead>
                <tr><th>Name</th><th>Email</th><th>Status</th><th>Action</th></tr>
              </thead>
              <tbody>
                {mechanics.map(m => (
                  <tr key={m._id}>
                    <td>{m.name}</td><td>{m.email}</td>
                    <td>{m.isApproved ? <span style={{color: 'green'}}>Approved</span> : <span style={{color: 'orange'}}>Pending</span>}</td>
                    <td><button className="btn-danger" onClick={() => deleteAccount(m._id, 'mechanic')}>Delete</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {currentView === 'users' && (
          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3>Registered Customers ({users.length})</h3>
              <button className="btn-danger" onClick={() => setCurrentView('dashboard')}>Close</button>
            </div>
            <table className="table">
              <thead><tr><th>Name</th><th>Email</th><th>Action</th></tr></thead>
              <tbody>
                {users.map(u => (
                  <tr key={u._id}>
                    <td>{u.name}</td><td>{u.email}</td>
                    <td><button className="btn-danger" onClick={() => deleteAccount(u._id, 'customer')}>Delete</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {selectedRequest && (
          <div className="modal-overlay" onClick={() => setSelectedRequest(null)}>
            <div className="modal-content card" onClick={(e) => e.stopPropagation()}>
              <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                <h3 style={{ margin: 0 }}>Request Overview</h3>
                <button style={{ background: 'none', border: 'none', fontSize: '24px' }} onClick={() => setSelectedRequest(null)}>×</button>
              </div>
              <div style={{ lineHeight: '1.8' }}>
                <p><strong>Customer:</strong> {selectedRequest.userId?.name || 'N/A'}</p>
                <p><strong>Contact:</strong> {selectedRequest.phone}</p>
                <p><strong>Location:</strong> {selectedRequest.location}</p>

                {/* UPDATED: Check both naming styles and fixed the URL string */}
                {(selectedRequest.latitude || selectedRequest.lat) && (selectedRequest.longitude || selectedRequest.lng) ? (
                  <div style={{ marginTop: '10px', marginBottom: '15px' }}>
                    <a 
                      href={`https://www.google.com/maps/search/?api=1&query=${selectedRequest.latitude || selectedRequest.lat},${selectedRequest.longitude || selectedRequest.lng}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none' }}
                    >
                      <button className="btn-primary" style={{ width: '100%', padding: '12px', backgroundColor: '#4285F4', color: 'white', border: 'none', cursor: 'pointer', borderRadius: '5px' }}>
                        🌐 View Customer Location on Map
                      </button>
                    </a>
                  </div>
                ) : (
                  <p style={{ color: '#888', fontSize: '13px' }}>📍 Coordinates not available for this request.</p>
                )}

                <p><strong>Mechanic:</strong> {selectedRequest.mechanicId?.name || 'Not assigned'}</p>
                <p><strong>Problem:</strong> {selectedRequest.problemType}</p>
                <p><strong>Vehicle:</strong> {selectedRequest.vehicleType}</p>
                <p><strong>Status:</strong> <span style={getStatusStyle(selectedRequest.status)}>{selectedRequest.status}</span></p>
              </div>
              <div style={{ marginTop: '20px', textAlign: 'right' }}>
                <button className="btn-danger" onClick={() => setSelectedRequest(null)}>Close</button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default AdminDashboard;